<template>
  <div class="page-layout">
    
    <el-row>
  <el-col :sm="24" :lg="24">
    <el-result icon="warning" title="">
    
         <template slot="subTitle">
            {{message}},请联系以下应用管理员:
            <el-tag  :key="openId" v-for="(openId, index) in openIds"><ww-open-data type="userName" :openid="openId"></ww-open-data><template v-if="(index + 1) !== openIds.length">,</template></el-tag>
        </template>

      <template slot="extra">
            

        <el-button type="danger" size="medium" @click="retry()">重试</el-button>
      </template>
    </el-result>
  </el-col>
</el-row>
  </div>
</template>

<script>
export default {
    components: {
        
    },
    data() {
        return {
            openIds: [],
            message: "加载中",
            loading: false,
        };
    },
    computed: {

    },
    created() {
        this.init();
    },
    methods: {
        retry() {
            delete localStorage.jwtToken;
            window.location.href = "https://yunkong.mlkee.com/frontend/"
        },
        init() {
            this.loading = true;
      
            this.$API.getAuthMessage().then((res) => {
                this.loading = false;
                this.message = res.data.message;
                this.openIds = res.data.openIds;
            }).catch((err) => {
                this.loading = false;
            });
        }
    },
}
</script>

<style scoped>

</style>
